module.exports = __webpack_public_path__ + "static/logo-bw-f706041a367df9d03c916adeaa0db325.svg";